import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    motorVariantAll: [],
    motorVariant: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const motorVariantSlice = createSlice({
    name: "motorVariant",
    initialState,
    reducers: {
        setMotorVariantAll: (state, action) => {
            state.motorVariantAll = action.payload;
        },
        setMotorVariant: (state, action) => {
            state.motorVariant = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
})

export const { setMotorVariantAll, setMotorVariant, setCurrentPage, setTotalPages, setRowsPerPage } = motorVariantSlice.actions;
export default motorVariantSlice.reducer;